import {React, useState} from "react";
import SwipeableCard from "./SwipeableCard";
import styled from 'styled-components'

const MyComponent = () => {
  
  const handleSwipeLeft = () => {
    console.log("Swiped left!");
  };

  const handleSwipeRight = () => {
    console.log("Swiped right!");
  };


  // With e.touches[0].clientX registers the touch in the screen in the X axis. The [0], it's because touches saves all your toches in an array. So you need to use index to register ONE touch.
  const handleTouch = (e) => {
    console.log('Touch:' + e.touches[0].clientX )
  }

  return (
    <Container>

        <SwipeableCard onSwipeLeft={handleSwipeLeft} onSwipeRight={handleSwipeRight}>
          <div>
            <p>Swipe Left or Right</p>
          </div>
        </SwipeableCard>
          <div onTouchStart={handleTouch}>
            <p>Tocame</p>
          </div>
    </Container>
  );
}

export default MyComponent;

const Container = styled.div`
    background-color: gray;
    width: 50%;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      background-color: pink;
      width: 50%;
      height: 50%;
    }

      p{
        user-select: none;
        text-align: center;
      }


`
